module.exports = __webpack_public_path__ + "static/08-puffins-zoom-fcd8555d979f746ad52716da5f1ef84f.jpg";